import React from 'react';

import classNames from 'classnames';

import IntlMessages from '@src/util/IntlMessages';

import type { ActiveUserKpis as ActiveUserKpisData } from '../../types';
import styles from './ActiveUserKpis.module.less';

interface ActiveUserKpisProps {
  kpis: ActiveUserKpisData;
  onKpiClick: (kpi: 'connected' | 'stalled' | 'lowBattery') => void;
}

interface KpiChipProps {
  value: React.ReactNode;
  labelId: string;
  tone: 'success' | 'danger' | 'warning';
  onClick: () => void;
}

const KpiChip: React.FC<KpiChipProps> = ({ value, labelId, tone, onClick }) => (
  <button type="button" className={classNames(styles.chip, styles[tone])} onClick={onClick}>
    <span className={styles.dot} />
    <span className={styles.value}>{value}</span>
    <span className={styles.label}>
      <IntlMessages id={labelId} />
    </span>
  </button>
);

const ActiveUserKpis: React.FC<ActiveUserKpisProps> = ({ kpis, onKpiClick }) => (
  <div className={styles.root}>
    <KpiChip
      value={`${kpis.connected}/${kpis.total}`}
      labelId="common.connected"
      tone="success"
      onClick={() => onKpiClick('connected')}
    />
    <KpiChip
      value={kpis.stalled}
      labelId="activeUserDashboard.kpi.stalled"
      tone="danger"
      onClick={() => onKpiClick('stalled')}
    />
    <KpiChip
      value={kpis.lowBattery}
      labelId="activeUserDashboard.kpi.lowBattery"
      tone="warning"
      onClick={() => onKpiClick('lowBattery')}
    />
  </div>
);

export default React.memo(ActiveUserKpis);
